import { ListItem, ListItemText } from '@material-ui/core';

import { ItemAvatar, SwitchModeIOS } from 'shared/components';

import { useCardProduct } from './hooks';
import makeClasses from './CardProduct.style';

import type { ReactNode } from 'react';
import type { IMenuProduct } from 'features/menu-page/domain';

export function CardProduct(props: Props) {
  const {
    product,
    isSelected = false,
    showHasCustomizations = false,
    children,
    toggleOnOff,
    onSelect = () => {},
  } = props;

  const { lang } = useCardProduct();

  const _classes = makeClasses();

  return (
    <ListItem
      component='article'
      selected={isSelected}
      data-product-id={product.id}
      onClick={() => onSelect(product)}
      classes={{ root: _classes.item }}
    >
      <ItemAvatar src={product.image} alt={product.name} />

      <section className={_classes.content}>
        <ListItemText
          primary={product.name}
          secondaryTypographyProps={{ component: 'div' }}
          secondary={
            <>
              <p aria-label='product-description'>{product.description}</p>
              {showHasCustomizations && product.hasCustomizations && (
                <p aria-label='show-customs-label'>
                  {lang.text.secondary.showCustoms}
                </p>
              )}
            </>
          }
          classes={{
            multiline: _classes.textMultiline,
            primary: _classes.textPrimary,
            secondary: _classes.textSecondary,
          }}
        />

        {children}
      </section>

      <section className={_classes.onOff}>
        <SwitchModeIOS
          color='secondary'
          stopPropagation={true}
          checked={product.isOn}
          disabled={!product.isAvailable}
          id={`switch-product-${product.id}`}
          onCheck={checked => toggleOnOff(checked, product)}
        />
      </section>
    </ListItem>
  );
}

interface Props {
  product: IMenuProduct;
  isSelected?: boolean;
  showHasCustomizations?: boolean;
  children?: ReactNode;
  toggleOnOff: (c: boolean, p: IMenuProduct) => void;
  onSelect?: (p: IMenuProduct) => void;
}
